module.exports = __webpack_public_path__ + "img/score_bg4.2558319.png";